import React from "react";
import {Box, Typography} from "@mui/material";

const Copyright = () => {
    return (
        <footer>
            <Box mt={8} sx={{bottom: '0%', position: 'fixed', width: '100%', backgroundColor: '#1976D2', p: 1}}>
                <Typography variant="body2" color="white" align="center">
                    {'Copyright © '}
                    Patrik Falk
                    {' '}
                    {new Date().getFullYear()}
                </Typography>
            </Box>
        </footer>
    );
}

export default Copyright;